import { secureModeFirmwareVersions } from '../../../../helpers/constants';

export default {
	title: 'settings',
	components: [
		{ title: 'eco_mode', component: 'eco_mode_g2' },
		{
			title: 'enhanced_security',
			component: 'enhanced_security_g2',
			min_ver: secureModeFirmwareVersions,
		},
		{ title: 'input_output', component: 'input_output_g2_rgbw' },
		{ title: 'input_name', component: 'input_name_per_id_g2' },
		{
			title: 'enable_input',
			component: 'enable_input_per_id_g2',
			min_ver: '1.0.7',
		},
		{ title: 'invert_switch', component: 'invert_switch_per_id_g2' },
		{
			title: 'min_brightness_on_toggle',
			component: 'min_brightness_on_toggle_g2',
		},
		{ title: 'transition_duration', component: 'transition_g2' },
		{ title: 'color_temperature_range', component: 'ct_range_g2', requires_config_key: 'ct_range' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
